import React from "react";
import { ToastContainer } from "react-toastify";

import ComplimentaryGiftCardForm from "./components/ComplimentaryGiftCardForm";

const ComplimentaryGiftCardApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <ComplimentaryGiftCardForm {...props} />
  </>
);

export default ComplimentaryGiftCardApp;
